/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrderEditRequest } from '../types/OrderEdit';
import type { OrderEditResponse } from '../types/OrderEdit';

export type OrdersCreateRequest = OrderEditRequest;
export type OrdersCreateResponse = OrderEditResponse;

export type OrdersCreateQuery = {};

/**
 * POST /dmx-server/orders/
 *
 * ```yaml
 * operationId: orders_create
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderEdit'
 *     description: ''
 * ```
 */
export const ordersCreateOperation = (rest?: OrdersCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/orders/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/orders/' };
  };

/**
 * POST /dmx-server/orders/
 *
 * ```yaml
 * operationId: orders_create
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderEdit'
 *     description: ''
 * ```
 */
export const ordersCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrdersCreateQuery;
  request: OrderEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderEditResponse>> => {
  const operation = ordersCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
